<template>
  <div>
    <p v-if="!favoritePost && !favoriteQA" class="text-center">
      <b
        >You have no favorites. Click on bookmark icon in post to add to your
        favorites.</b
      >
    </p>
    <!-- <div v-if="favorites">
      <div v-for="(favorite, index) in favorites" :key="index">
        <FavPost
          v-if="
            favorite.favorite && favorite.favorite[0].content_type === 'post'
          "
          :postData="favorite.favorite[0]"
        ></FavPost>
        <Question
          v-if="
            favorite.favorite &&
              favorite.favorite[0].content_type === 'question'
          "
          :quesData="favorite.favorite[0]"
        ></Question>
      </div>
      <span
        v-if="this.favorites.length != this.pagination.total_count"
        :style="{
          color: getPrimaryColor(),
          textAlign: 'center',
          display: 'block',
          cursor: 'pointer'
        }"
        @click="fetch(true)"
        >View More</span
      >
    </div> -->

    <div v-if="favoritePost">
      <!-- Add Save Posts && Save Question -- h3 -->
      <h3 class="title">Saved Posts</h3>
      <div v-for="(favorite, index) in favoritePost" :key="index">
        <FavPost
          v-if="favorite.favorite[0].content_type === 'post'"
          :postData="favorite.favorite[0]"
        ></FavPost>
        <!-- <Question
          v-if="favorite.favorite[0].content_type === 'question'"
          :quesData="favorite.favorite[0]"
        ></Question> -->
      </div>
      <span
        v-if="favoritePost.length < paginationPost.total_count"
        :style="{
          color: getPrimaryColor(),
          textAlign: 'center',
          display: 'block',
          cursor: 'pointer'
        }"
        @click="fetchPost(true)"
        >More Posts</span
      >
    </div>

    <div v-if="favoriteQA">
      <!-- Add Save Posts && Save Question -- h3 -->
      <h3 class="title">Saved Questions</h3>
      <div v-for="(favorite, index) in favoriteQA" :key="index">
        <!-- <FavPost
          v-if="favorite.favorite[0].content_type === 'post'"
          :postData="favorite.favorite[0]"
        ></FavPost> -->
        <Question
          v-if="favorite.favorite[0].content_type === 'question'"
          :quesData="favorite.favorite[0]"
        ></Question>
      </div>
      <span
        v-if="favoriteQA.length < paginationQA.total_count"
        :style="{
          color: getPrimaryColor(),
          textAlign: 'center',
          display: 'block',
          cursor: 'pointer'
        }"
        @click="fetchQA(true)"
        >More Questions</span
      >
    </div>

    <div v-if="favoritePoll">
      <h3 class="title">Saved Polls</h3>
      <div v-for="(favorite, index) in favoritePoll" :key="index">
        <UserPollCard
          v-if="favorite.favorite[0].content_type === 'poll'"
          :pollData="favorite.favorite[0]"
        ></UserPollCard>
      </div>
      <span
        v-if="favoritePoll.length < paginationPoll.total_count"
        :style="{
          color: getPrimaryColor(),
          textAlign: 'center',
          display: 'block',
          cursor: 'pointer'
        }"
        @click="fetchPoll(true)"
        >More Polls</span
      >
    </div>
  </div>
</template>

<script>
import FavPost from "../../home/Post";
import Question from "../Patient/QA/Question";
import UserPollCard from "../../home/poll/UserPollCard.vue";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";

const UserRepository = RepositoryFactory.get("user");

export default {
  name: "AdvocateFavorites",
  components: {
    FavPost,
    Question,
    UserPollCard
  },
  data() {
    return {
      favorites: [],
      pagination: null,
      favoritePost: [],
      favoriteQA: [],
      favoritePoll: [],
      paginationPost: null,
      paginationQA: null,
      currentPagePost: 1,
      currentPageQA: 1,
      currentPagePoll: 1,
      currentPage: 1,
      limit: 5,
      showNo: false
    };
  },

  created() {
    //  this.fetch();
    this.fetchPost();
    this.fetchQA();
    this.fetchPoll();
  },

  methods: {
    fetch(append = false) {
      UserRepository.getFavorites(
        this.currentPage,
        this.limit,
        this.currentCircle.id,
        this.authUser.user
      )
        .then(res => {
          this.showNo = true;
          if (append) {
            this.favorites.push(...res.data.data.data);
          } else {
            if (res.data) {
              this.favorites = res.data.data.data;
              this.pagination = res.data.data.paginator;
            }
          }
          this.currentPage += 1;
        })
        .catch(err => {});
    },
    fetchPost(append = false) {
      //  this.loading = true ;
      UserRepository.getFavoritesPost(
        this.currentPagePost,
        this.limit,
        this.currentCircle.id,
        this.authUser.user
      )
        .then(res => {
          //   this.loading = false ;
          this.showNo = true;
          if (append) {
            this.favoritePost.push(...res.data.data.data);
          } else {
            if (res.data) {
              this.favoritePost = res.data.data.data;
              this.paginationPost = res.data.data.paginator;
            }
          }
          this.currentPagePost += 1;
          console.log(this.favoritePost, "log favorite posts------>");
        })
        .catch(err => {});
    },
    fetchQA(append = false) {
      // this.loading = true ;
      UserRepository.getFavoritesQA(
        this.currentPageQA,
        this.limit,
        this.currentCircle.id,
        this.authUser.user
      )
        .then(res => {
          // this.loading = false ;
          this.showNo = true;
          if (append) {
            this.favoriteQA.push(...res.data.data.data);
          } else {
            if (res.data) {
              this.favoriteQA = res.data.data.data;
              this.paginationQA = res.data.data.paginator;
            }
          }
          this.currentPageQA += 1;
          console.log(this.favoriteQA, "log favorites QA------>");
        })
        .catch(err => {});
    },
    fetchPoll(append = false) {
      // this.loading = true ;
      UserRepository.getFavoritesPolls(
        this.currentPagePoll,
        this.limit,
        this.currentCircle.id,
        this.authUser.user
      )
        .then(res => {
          // this.loading = false ;
          this.showNo = true;
          if (append) {
            this.favoritePoll.push(...res.data.data.data);
          } else {
            if (res.data) {
              this.favoritePoll = res.data.data.data;
              this.paginationPoll = res.data.data.paginator;
            }
          }
          this.currentPageQA += 1;
          console.log(this.favoritePoll, "log favorites Poll------>");
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Advocate/AdvocateFavorites.vue